import { useContext, useEffect } from 'react'
import { AuthenticationContext } from '../AuthenticationContext'
import { evaluateTreatment, isTreatmentOn } from '../domain/features/featureFlags'
import { useFeaturesQuery } from '../domain/features/featuresQueries'
import { useFeatureUsageReporter } from '../domain/features/featureUsageReporter'

const useFeatureFlag = (featureName: string, defaultValue: boolean = false): boolean => {
  const { currentUser } = useContext(AuthenticationContext)
  const { data } = useFeaturesQuery()
  const { reportFeatureFlagEvaluation } = useFeatureUsageReporter()

  const treatment =
    data && currentUser
      ? evaluateTreatment(data.features, featureName, currentUser.tenant.id, data.mySegments, 'control')
      : null

  useEffect(() => {
    if (treatment !== null) {
      reportFeatureFlagEvaluation(featureName, treatment)
    }
  }, [featureName, treatment, reportFeatureFlagEvaluation])

  if (treatment === null) {
    return defaultValue
  }
  return isTreatmentOn(treatment) ? true : defaultValue
}

export default useFeatureFlag
